import { useEffect } from "react";
import { useAtom } from "jotai";
import { puntajeTotalEvaluacionConductorAtom } from "../../BandejaEvaluacionStorage";
import usePreguntasCalidad from "./usePreguntasCalidad";
import usePreguntasProactividad from "./usePreguntasProactividad";
import usePreguntasOrientacionResultados from "./usePreguntasOrientacionResultados";
import usePreguntasRelacionesInterpersonales from "./usePreguntasRelacionesInterpersonales";
import usePreguntasLimpiezaSeguridad from "./usePreguntasLimpiezaSeguridad";
import usePreguntasTrabajoEnEquipo from "./usePreguntasTrabajoEnEquipo";
import { useState } from "react";
import usePreguntasPuntualidad from "./usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "./usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "./usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "./usePreguntasActitudTrabajoEquipo";
import usePreguntasImagenRepresentacionEmpresa from "./usePreguntasImagenRepresentacionEmpresa";
import usePreguntasPredisposicion from "./usePreguntasPredisposicion";

const useResultadoEvaluacionConductor = () => {
	const { puntajeTotal: puntajeTotalPuntualidad } = usePreguntasPuntualidad();
	const { puntajeTotal: puntajeTotalComunicacionReportes} = usePreguntasComunicacionReportes();
	const { puntajeTotal: puntajeTotalResponsabilidadManejoVehiculo } = usePreguntasResponsabilidadManejoVehiculo();
	const { puntajeTotal: puntajeTotalActitudTrabajoEquipo } = usePreguntasActitudTrabajoEquipo();
	const { puntajeTotal: puntajeTotalImagenRepresentacionEmpresa } = usePreguntasImagenRepresentacionEmpresa();
	const { puntajeTotal: puntajeTotalPredisposicion } = usePreguntasPredisposicion();
	const [puntajeTotalEvaluacionConductor, setPuntajeTotalEvaluacionConductor] = useAtom(puntajeTotalEvaluacionConductorAtom);

	const [noAptoStyle, setNoAptoSyle] = useState("");
	const [aptoConObservacionesStyle, setAptoConObservaciones] = useState("");
	const [buenoStyle, setBuenoStyle] = useState("");
	const [destacadoStyle, setDestacadoStyle] = useState("");
	const [excelenteStyle, setExcelenteStyle] = useState("");

	const itemSeleccionado = {
		background: "#faad14",
	};

	useEffect(() => {
		setPuntajeTotalEvaluacionConductor(
			puntajeTotalPuntualidad +
				puntajeTotalComunicacionReportes +
				puntajeTotalResponsabilidadManejoVehiculo +
				puntajeTotalActitudTrabajoEquipo +
				puntajeTotalImagenRepresentacionEmpresa +
				puntajeTotalPredisposicion
		);
	}, [
		puntajeTotalPuntualidad,
		puntajeTotalComunicacionReportes,
		puntajeTotalResponsabilidadManejoVehiculo,
		puntajeTotalActitudTrabajoEquipo,
		puntajeTotalImagenRepresentacionEmpresa,
		puntajeTotalPredisposicion,
	]);

	useEffect(() => {
		setNoAptoSyle(puntajeTotalEvaluacionConductor >= 0 && puntajeTotalEvaluacionConductor <= 50 ? itemSeleccionado : "");
		setAptoConObservaciones(puntajeTotalEvaluacionConductor >= 51 && puntajeTotalEvaluacionConductor <= 75 ? itemSeleccionado : "");
		setBuenoStyle(puntajeTotalEvaluacionConductor >= 76 && puntajeTotalEvaluacionConductor <= 85 ? itemSeleccionado : "");
		setDestacadoStyle(puntajeTotalEvaluacionConductor >= 86 && puntajeTotalEvaluacionConductor <= 95 ? itemSeleccionado : "");
		setExcelenteStyle(puntajeTotalEvaluacionConductor >= 96 && puntajeTotalEvaluacionConductor <= 100 ? itemSeleccionado : "");
	}, [puntajeTotalEvaluacionConductor]);

	return {
		puntajeTotalEvaluacionConductor,
		noAptoStyle,
		aptoConObservacionesStyle,
		buenoStyle,
		destacadoStyle,
		excelenteStyle,
	};
};

export default useResultadoEvaluacionConductor;
